<template>
	<b-container fluid class="m-0 p-0 vh-100 h-100 d-flex flex-column">
        <b-row id="SupervisionRow1" class="p-0 w-100 no-gutters">
            <Header/>
        </b-row>
        <b-row id="SupervisionRow2" class="p-0 w-100 no-gutters flex-grow-1">
            <b-col class="w-100 h-100 m-0 p-0">
                <b-row class="w-100 h-100 m-0 p-0 position-absolute">
                    <b-col cols="1.5" class="h-100 px-3 overflow-auto">
                        <b-card-group deck class="h-100">
                            <b-card no-body class="font-weight-bold d-flex flex-column mh-100 h-100 m-0 p-0" >
                                <b-list-group id="adminList">
                                    <!-- Occurence des fonctions administrateur pour la création de la sidebar -->
                                    <b-list-group-item v-for="(feature, index) in features"  :key="index"
                                                       @click="target = feature.Target; featureName = feature.Name;"
                                                       class="border-bottom text-truncate p-2" href="#">
                                        {{ feature.Label }}
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-card-group>
                    </b-col>
                    <b-col class="h-100 p-0">
                        <template v-if="target === ''">
                            <Welcome :DisplayBrand="true" Variant="primary" />
                        </template>
                        <template v-else>
                            <!-- Composant Vue ou Iframe pour afficher la fonction -->
                            <component v-bind:is="target" Variant="quartary" class="p-1"
                                       :Interop="target ==='IFrameLoader' ? 'Supervision/' + featureName : ''"
                                       :Link="target ==='IFrameLoader' ? 'Supervision/' + featureName + '_Page.aspx' : ''"/>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
	import { API_URL } from '@/App.settings';
	import { Component, Vue } from 'vue-property-decorator';
	import { LinkUtils } from "@/components/commons/Utils";
	import { mixins } from 'vue-class-component';
	import axios from 'axios';

	// Composants
	import Welcome from '@/components/commons/Welcome.vue';
	import IFrameLoader from "@/components/commons/IFrameLoader.vue";
	import Header from '@/components/SupervisionPage/Header.vue';

    // Liste des composants de fonction de supervision
    import TertiaryDecree from '@/components/SupervisionPage/TertiaryDecree.vue';
    import ExportDJU from '@/components/SupervisionPage/ExportDJU.vue';
    import Profil from './commons/Profil.vue';
    import ServiceLogin from './SupervisionPage/ServiceLogin.vue';
	@Component({
		components: {
			IFrameLoader,
			Welcome,
			Header,
            TertiaryDecree,
            ExportDJU,
			Profil,
            ServiceLogin
		}
	})
	export default class SupervisionPage extends mixins(LinkUtils) {

        private showOverlay = false;

		// Liste des fonctions
		private features: SupervisionFeature[] = [];
		// Fonction ciblée
		private target: string = "";
		// Nom de la fonction
		private featureName: string = ""

		// Cherche la liste des fonctions lors de la création du composant Supervision
		async created() {
			var data = {
				Token: Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : ""
			};

			await axios.post(API_URL + "supervision/getFeatures", data).then((response) => {
				if (response && response.data) {
					this.features = response.data;
				}
			})
			.catch(err => {
                console.error(err);
                this.$bvToast.toast("Une erreur s'est produite.", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
		}
	}

	class SupervisionFeature{
		Name: string;
		Label: string;
		Target: string;
	}
</script>

<style scoped>

</style>